/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
const defaultDisposeFlag = {
    disposeGeometry: true,
    disposeMaterial: true,
    disposeTexture: true,
};
/**
 * common object funktions
 */
export class Objects {
    /**
     * handles disposing
     * @param object
     */
    static dispose(object) {
        // tslint:disable-next-line:no-any
        const obj = object;
        let flags = defaultDisposeFlag;
        if (obj.userData.disposeFlags) {
            flags = obj.userData.disposeFlags;
        }
        if (!!obj.userData.disposer) {
            obj.userData.disposer();
        }
        if (flags.disposeGeometry && !!obj.geometry) {
            obj.geometry.dispose();
        }
        if (flags.disposeMaterial && !!obj.material) {
            if (Array.isArray(obj.material)) {
                obj.material.forEach((m) => m.dispose());
            }
            else {
                obj.material.dispose();
            }
        }
        if (flags.disposeTexture && !!obj.texture) {
            obj.texture.dispose();
        }
    }
}
//# sourceMappingURL=Objects.js.map